export const proxy = process.env.REACT_APP_PROXY_URL
  ? `${process.env.REACT_APP_PROXY_URL}:${process.env.REACT_APP_PROXY_PORT}/`
  : '';

export const partnerKey = process.env.REACT_APP_PARTNER_KEY;
